export function validateObjectHasEmptyFields(object) {
  let result = false;
  Object.entries(object).forEach(([_, value]) => {
    if ([undefined, null, ''].includes(value)) {
      result = true;
    }
  });
  return result;
}
